<template>
  <!--  voting -->
  <div class="a-ui-tab__content">
    <label class="a-ui-tab__title">Проекты Протоколов для голосования</label>

    <template v-for="draftProtocol in protocol.drafts">
      <div class="a-ui-tab__file-flex-block" >
        <div class="a-ui-tab__file-item-left">
          <div class="a-ui-tab__file-block-number">
            {{draftProtocol.version}}
          </div>

          <file-link :name="draftProtocol.fileName"
                     :link="externalLink(draftProtocol.uid)"
                     :signed="draftProtocol.hasSign"
                     @onsigncheck="onFileSignCheckClick(draftProtocol.version)">
            <div class="input-file__actual-block">
              <div class="input-file__actual-img input-file__hidden">
                <img src="@/assets/img/static/clientarea-details.svg" alt="">
              </div>
              <div class="input-file__actual" v-if="draftProtocol.isActual">{{$t('form.lot.actual-file-version')}}</div>
              <div class="input-file__not-actual" v-else>{{$t('form.lot.legacy-file-version')}}</div>
            </div>
          </file-link>
        </div>

        <div class="a-ui-tab__file-item-right" v-if="draftProtocol.permissions.CAN_RECOVERY_PROTOCOL">
          <button class="gui-btn gui-btn--red gui-btn--w-160"
                  v-if="!draftProtocol.isActual"
                  @click.prevent="onRestoreDraftProtocolClick(({type: protocol.type.valueOf(), version: draftProtocol.version}))">
            {{$t('buttons.restore-file')}}
          </button>
        </div>
      </div>

      <div class="a-container-form" v-if="!draftProtocol.isActual">
        <button class="gui-btn gui-btn--red"
                @click.prevent="draftProtocol.visible=!draftProtocol.visible">
          Смотреть голосование комиссией
        </button>
      </div>

      <div class="a-container-form">
        <label class="a-label a-label--w-280">Статус</label>
        <p class="a-input a-input--disabled">
          <span v-if="draftProtocol.beginTime">
            с <date-time tag="span" :tz="false" :value="draftProtocol.beginTime"></date-time>
          </span>

          <span v-if="draftProtocol.voteTime">
            по <date-time tag="span" :tz="false" :value="draftProtocol.voteTime"></date-time>
          </span>

          <span v-if="draftProtocol.version === 1">
            назначено голосование
          </span>
          <span v-else>
            назначено повторное голосование
          </span>
        </p>
      </div>

      <div class="a-container-form">
        <label class="a-label a-label--w-280">Причина</label>
        <p class="a-input a-input--disabled">{{draftProtocol.reason}}</p>
      </div>

      <v-collapse-wrapper :active="false">
        <div class="a-ui-tab__control-panel"
             v-if="(draftProtocol.visible || draftProtocol.isActual) || (lot.permissions.CAN_VIEW_VOTING_RESULTS && (draftProtocol.visible || draftProtocol.isActual))">
          <div class="a-ui-tab__control a-width-100-percent" v-collapse-toggle>
            <div class="a-ui-tab__arrow"></div>
            <div class="a-ui-tab__number-block"></div>
            <div class="a-ui-tab__title">Голосование</div>
          </div>

          <div v-collapse-content>
            <div class="a-container-form" v-if="draftProtocol.visible || draftProtocol.isActual">
              <voting-for-draft-protocol :lot="lot" :draft="draftProtocol"></voting-for-draft-protocol>
            </div>

            <div class="a-container-form" v-if="lot.permissions.CAN_VIEW_VOTING_RESULTS && (draftProtocol.visible || draftProtocol.isActual)">
              <voting-result-for-draft-protocol :lot="lot" :draft="draftProtocol"></voting-result-for-draft-protocol>
            </div>
          </div>
        </div>
      </v-collapse-wrapper>
    </template>

    <template v-if="protocol.permissions.CAN_UPLOAD_PROTOCOL">
      <file-picker label="Прикрепить для голосования комиссией"
                   :signing="false"
                   @prepared="onDraftReady($event, { type: protocol.type.valueOf() })">
      </file-picker>
    </template>

    <confirmation-dialog ref="addProject">
      <template v-slot:body>
        <div class="a-container-form"
             :class="{ 'a-input-group--error': $v.voting.to.$error }">
          <div class="a-label a-label--auto">Голосования до: </div>
          <div class="a-flex-start a-width-100-percent">
            <div>
              <div class="a-input-group" :class="{ 'a-input-group--error' : $v.voting.to.$error }">
                <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
                <date-picker v-model="voting.to.date"></date-picker>
              </div>
            </div>
            <div>
              <div class="a-input-group " :class="{ 'a-input-group--error' : $v.voting.to.$error }">
                <div class="a-input-group__prepend "><img src="@/assets/img/static/time.svg" alt=""></div>
                <cleave v-model="voting.to.time" :options="time"></cleave>
              </div>
            </div>
          </div>
        </div>

        <div class="a-container-form"
             :class="{ 'a-input-group--error': $v.voting.reason.$error }"
             v-if="isReasonRequired">
          <div class="a-label a-label--auto">Причина: </div>
          <div class="a-form-field a-width-100-percent">
            <textarea class="a-textarea" v-model="voting.reason"></textarea>
            <span class="a-validation-error" v-if="$v.voting.$dirty && !$v.voting.reason.required">{{$t('labels.mandatory-field')}}</span>
          </div>
        </div>
      </template>
    </confirmation-dialog>

  </div>
</template>

<script>
  import { requiredIf, required } from '@/validators'

  import VotingForDraftProtocol from "./VotingForDraftProtocol";
  import VotingResultForDraftProtocol from "./VotingResultForDraftProtocol";
  import ConfirmationDialog from "@/components/common/dialogs/ConfirmationDialog";
  import Cleave from 'vue-cleave-component'

  export default {
    props: {
      lot: {
        type: Object,
        required: true
      },

      protocol: {
        type: Object,
        required: true
      }
    },

    components: {
      Cleave,
      VotingForDraftProtocol,
      VotingResultForDraftProtocol,
      ConfirmationDialog
    },

    data: () => ({
      voting: {
        to: {
          date: undefined,
          time: undefined
        },
        reason: undefined
      },

      time: {
        time: true,
        timePattern: ['h', 'm'],
        delimiter: ':'
      }
    }),

    computed: {
      isReasonRequired() {
        return this.protocol.drafts.length > 0;
      }
    },

    validations: {
      voting: {
        to: {
          date: {
            required
          },

          time: {
            valid: function() {
              if (!this.voting.to.date || !this.voting.to.time) return false;

              const till = new Date(this.voting.to.date);
              till.setHours(this.voting.to.time.slice(0, 2), this.voting.to.time.slice(2));

              return till > new Date();
            }
          }
        },

        reason: {
          required: requiredIf(function() {
            return this.isReasonRequired;
          }),
        }
      }
    },

    methods: {
      async onDraftReady(file, { type }) {
        this.voting.to.date = new Date();
        this.voting.reason = undefined;

        const onConfirm = () => {
          this.$v.$touch();
          if (this.$v.$invalid) return false;

          const till =  new Date(this.voting.to.date);
          till.setHours(this.voting.to.time.slice(0, 2), this.voting.to.time.slice(2));

          this.addDraftProtocol(file, type, till, this.voting.reason);
          return true;
        };

        this.$refs.addProject.open({
          title: 'Проект для голосования',
          onConfirm() {
            if (onConfirm()) {
              this.close();
            }
          },

          onCancel() {
            this.close();
          }
        });
      },

      addDraftProtocol(file, type, till, reason) {
        if (file instanceof File) {
          file = {
            file,
            sign: undefined
          }
        }

        return this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('addDraftToProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              file: file.file,
              sign: file.sign,
              timeTo: till,
              reason
            });
          }
          catch(e) {
            console.error('failed attaching draft to protocol', e);
            this.globalErrorHandler(e, {
              'BAD_SIGNATURE': 'errors.public-lot.attaching-file-to-protocol.bad-signature'
            }, 'errors.public-lot.attaching-file-to-protocol.unknown');
          }
        })
      },

      async onRestoreDraftProtocolClick({type, version}) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('restoreDraftProtocol', {
              lotId: this.lot.id,
              protocolType: type,
              version: version
            });
          }
          catch(e) {
            console.error('failed restoring draft protocol', e);
            this.globalErrorHandler(e);
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
